import { APIClient } from "../helpers/api_helper";
import { ApiResponse } from "../types/api";

const api = new APIClient();

export interface PublicClubPlan {
  id: number;
  name: string;
  description?: string | null;
  price: number;
  billing_interval: string;
  monthly_visit_limit?: number | null;
}

export interface PublicClubJoinData {
  studio_name?: string | null;
  client_first_name?: string | null;
  suggested_plan_id?: number | null;
  plans: PublicClubPlan[];
  current_membership?: {
    status: string;
    plan_name?: string | null;
    plan_id: number;
  } | null;
  expires_at: number;
}

export interface PublicClubJoinResult {
  subscription_id: number;
  status: string;
  payment_link_url: string | null;
  plan_name?: string | null;
}

export const getPublicClubJoin = (
  token: string
): Promise<ApiResponse<PublicClubJoinData>> =>
  api.get<ApiResponse<PublicClubJoinData>>(
    `/public/club/${encodeURIComponent(token)}`
  );

export const postPublicClubJoin = (
  token: string,
  payload: {
    client_subscription_plan_id: number;
    payment_method?: string;
    accepted_terms: boolean;
  }
): Promise<ApiResponse<PublicClubJoinResult>> =>
  api.create<ApiResponse<PublicClubJoinResult>>(
    `/public/club/${encodeURIComponent(token)}`,
    payload
  );
